import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";
import StaffIcon from "../../../resources/images/icon-staff.png";
import CompensationIcon from "../../../resources/images/icon-compensation.png";
import LearningIcon from "../../../resources/images/icon-learning.png";
import HealthIcon from "../../../resources/images/icon-health.png";
import {
  getSelectedCompany,
  getSelectedOffice,
  removeSpace,
} from "../../Global/CustomFunctions";

class Dashboard extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      comp: "",
      ofc: "",
    };
    this.redirectToOfficeDashboard = this.redirectToOfficeDashboard.bind(this);
  }
  componentDidMount() {
    if (
      localStorage.selectedCompany === undefined ||
      localStorage.selectedOffice === undefined
    ) {
      this.props.history.push("/");
    } else {
      const company = getSelectedCompany();
      const office = getSelectedOffice();
      this.setState({
        comp: company.name,
        ofc: removeSpace(office.name.toLowerCase()),
      });
    }
  }
  redirectToOfficeDashboard() {
    this.props.history.push(`/${this.state.comp}/offices`);
  }
  render() {
    let user = JSON.parse(localStorage.userInfo);
    //let role = user.userInfo.roles;
    let isAdmin = false; // Todo: handle this through backend and do operation here of admin and user
    if (user.role !== "admin") {
      isAdmin = true;
    }

    const link = `/${
      this.state.comp + "/" + this.state.ofc
    }/dashboard/employees`;
    const { t } = this.props;

    return (
      <div>
        <h1 className="innerHeadings">
          <Button
            className="officeBackBtn"
            onClick={this.redirectToOfficeDashboard}
          />
          <span className="coHeading">{t("app.dashboard.title")} </span>
        </h1>
        <div className="dashboard-container">
          <div className="dashboardInner">
            {isAdmin && (
              <ul className="dashboard-icons">
                <li>
                  <Link to={link}>
                    <div>
                      <img src={StaffIcon} alt={t("app.dashboard.staffMembers")} />
                    </div>
                    <h2>{t("app.dashboard.staffMembers")}</h2>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <div>
                      <img src={HealthIcon} alt={t("app.dashboard.healthSafety")} />
                    </div>
                    <h2>{t("app.dashboard.healthSafety")}</h2>
                  </Link>
                </li>
              </ul>
            )}
            {!isAdmin && (
              <ul className="dashboard-icons">
                <li>
                  <Link to={link}>
                    <div>
                      <img src={StaffIcon} alt={t("app.dashboard.staffMembers")} />
                    </div>
                    <h2>{t("app.dashboard.staffMembers")}</h2>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div>
                      <img
                        src={CompensationIcon}
                        alt={t("app.dashboard.compensationBenefits")}
                      />
                    </div>
                    <h2>{t("app.dashboard.compensationBenefits")}</h2>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div>
                      <img
                        src={LearningIcon}
                        alt={t("app.dashboard.learningDevelopment")}
                      />
                    </div>
                    <h2>{t("app.dashboard.learningDevelopment")}</h2>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div>
                      <img src={HealthIcon} alt={t("app.dashboard.healthSafety")} />
                    </div>
                    <h2>{t("app.dashboard.healthSafety")}</h2>
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Dashboard);
